import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons"

export const ShieldAlt = (props) => {
  return <FontAwesomeIcon faIcon={faShieldAlt} {...props} />
}
